module.exports = __webpack_public_path__ + "static/presuasion-fe528cf9ab15a42fcb9c8ad0a38c791b.jpg";